import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import logo from "../../assets/images/logo.png";
import ConfirmModal from "../ConfirmModal/ConfirmModal";
import Logout from "../Logout/Logout";
import "./style.css";
function SidebarUi({ logOut, decodedToken, cenData }) {
  const [isMasterDataOpen, setIsMasterDataOpen] = useState(false);
  const [isAuditFormOpen, setIsAuditFormOpen] = useState(false);
  const url = window.location.pathname;
  const { id } = useParams();

  // Toggle dropdown state
  const toggleDropdown = () => {
    setIsMasterDataOpen((prev) => !prev);
  };
  const toggleDropdownAuditForm = () => {
    setIsAuditFormOpen((prev) => !prev);
  };
  useEffect(() => {
    if (
      url === `${process.env.REACT_APP_BASE_NAME}/master-data/rrb` ||
      url === `${process.env.REACT_APP_BASE_NAME}/master-data/create-rrb` ||
      url === `${process.env.REACT_APP_BASE_NAME}/master-data/update-rrb` ||
      url === `${process.env.REACT_APP_BASE_NAME}/master-data/city` ||
      url === `${process.env.REACT_APP_BASE_NAME}/master-data/create-city` ||
      url === `${process.env.REACT_APP_BASE_NAME}/master-data/update-city` ||
      url === `${process.env.REACT_APP_BASE_NAME}/master-data/state` ||
      url === `${process.env.REACT_APP_BASE_NAME}/master-data/create-state` ||
      url === `${process.env.REACT_APP_BASE_NAME}/master-data/update-state`
    ) {
      setIsMasterDataOpen(true);
    }
    if (
      url === `${process.env.REACT_APP_BASE_NAME}/audits-questions` ||
      url === `${process.env.REACT_APP_BASE_NAME}/create-audit-question` ||
      url === `${process.env.REACT_APP_BASE_NAME}/update-audit-question` ||
      url === `${process.env.REACT_APP_BASE_NAME}/audits-images` ||
      url === `${process.env.REACT_APP_BASE_NAME}/create-audit-images` ||
      url === `${process.env.REACT_APP_BASE_NAME}/update-audit-images` ||
      url === `${process.env.REACT_APP_BASE_NAME}/audits-extras` ||
      url === `${process.env.REACT_APP_BASE_NAME}/create-audit-extras` ||
      url === `${process.env.REACT_APP_BASE_NAME}/update-audit-extras`
    ) {
      setIsAuditFormOpen(true);
    }
  }, [url]);

  return (
    <div>
      {/* Main Sidebar Container */}
      <aside className="main-sidebar sidebar-dark-primary elevation-4">
        {/* Brand Logo */}
        <Link to="/" className="brand-link text-center pr-3">
          <img src={logo} alt="RRB" style={{ height: "60px" }} />
        </Link>
        <div className="brand-link sidebar_login_data">
          <p className="text-center">
            <span>
              {" "}
              {decodedToken?.role == 1
                ? "RRB Admin"
                : decodedToken?.role == 4
                ? "Nodal Admin"
                : decodedToken?.role == 5
                ? "ECA Admin"
                : "Super Admin"}
            </span>
          </p>
          {(decodedToken?.role == 1 || decodedToken?.role == 5) && (
            <p
              className="text-center"
              style={{
                maxWidth: "200px",
                wordWrap: "break-word",
                whiteSpace: "normal",
                marginBottom: "0px",
                fontWeight: "500",
                fontSize: "16px",
              }}
            >
              <span className="sidebar-head-text">
                {decodedToken?.rrb_name}
              </span>
            </p>
          )}
        </div>
        {/* Sidebar */}
        <div style={{ height: "calc(100vh - 9.5 rem)" }} className="sidebar">
          {/* Sidebar Menu */}
          <nav className="mt-2 ">
            <ul
              className="nav nav-pills nav-sidebar flex-column  pb-6"
              data-widget="treeview"
              role="menu"
              data-accordion="false"
            >
              {/* Add icons to the links using the .nav-icon class
       with font-awesome or any other icon font library */}
              {decodedToken?.role !== 5 ? (
                <li className="nav-item ">
                  <Link
                    to="/"
                    className={`nav-link ${
                      url === `${process.env.REACT_APP_BASE_NAME}` && "active"
                    }`}
                  >
                    <i className="nav-icon fas fa-tachometer-alt" />
                    <p>Dashboard</p>
                  </Link>
                </li>
              ) : null}
              {decodedToken?.role == 4 || decodedToken?.role == 3 ? (
                <li className="nav-item">
                  <Link
                    to="/cen"
                    className={`nav-link ${
                      (url === `${process.env.REACT_APP_BASE_NAME}/cen` ||
                        url ===
                          `${process.env.REACT_APP_BASE_NAME}/create-cen` ||
                        url ===
                          `${process.env.REACT_APP_BASE_NAME}/update-cen`) &&
                      "active"
                    }`}
                  >
                    <i className="nav-icon fas fa-edit" />
                    <p>CEN (Exams)</p>
                  </Link>
                </li>
              ) : null}
              {/* <li className="nav-item">
                <Link
                  to="/customer"
                  className={`nav-link ${
                    url === `${process.env.REACT_APP_BASE_NAME}/customer` &&
                    "active"
                  }`}
                >
                  <i className="nav-icon fas fa-th" />
                  <p>Customer</p>
                </Link>
              </li> */}
              {decodedToken?.role == 1 ||
              decodedToken?.role == 4 ||
              decodedToken?.role == 3 ? (
                <li className="nav-item">
                  <Link
                    to="/audits"
                    className={`nav-link ${
                      (url === `${process.env.REACT_APP_BASE_NAME}/audits` ||
                        url ===
                          `${process.env.REACT_APP_BASE_NAME}/audits/view-audit`) &&
                      "active"
                    }`}
                  >
                    <i className="nav-icon fas fa-audio-description" />
                    <p>Audits</p>
                  </Link>
                </li>
              ) : null}
              {decodedToken?.role == 5 ? (
                <li className="nav-item">
                  <Link
                    to="/eca-audits"
                    className={`nav-link ${
                      (url ===
                        `${process.env.REACT_APP_BASE_NAME}/eca-audits` ||
                        url ===
                          `${process.env.REACT_APP_BASE_NAME}/eca-audits/view-audit`) &&
                      "active"
                    }`}
                  >
                    <i className="nav-icon fas fa-audio-description" />
                    <p>Audits</p>
                  </Link>
                </li>
              ) : null}
              {decodedToken?.role == 3 ||
              decodedToken?.role == 4 ||
              decodedToken?.role == 1 ? (
                <li className="nav-item">
                  <Link
                    to="/re-audits"
                    className={`nav-link ${
                      (url === `${process.env.REACT_APP_BASE_NAME}/re-audits` ||
                        url ===
                          `${process.env.REACT_APP_BASE_NAME}/re-audits`) &&
                      "active"
                    }`}
                  >
                    <i class="nav-icon fas fa-recycle"></i>
                    <p>Re-Audits</p>
                  </Link>
                </li>
              ) : null}
              {(decodedToken?.role == 3 ||
                decodedToken?.role == 4 ||
                decodedToken?.role == 1) &&
              cenData?.length > 1 ? (
                <li className="nav-item">
                  <Link
                    to="/duplicate-audits"
                    className={`nav-link ${
                      (url ===
                        `${process.env.REACT_APP_BASE_NAME}/duplicate-audits` ||
                        url ===
                          `${process.env.REACT_APP_BASE_NAME}/duplicate-audits`) &&
                      "active"
                    }`}
                  >
                    <i class="nav-icon fas fa-copy"></i>
                    <p>Duplicate-Audits</p>
                  </Link>
                </li>
              ) : null}
              {decodedToken?.role == 3 && (
                <>
                  <li
                    className={`nav-item ${isAuditFormOpen ? "" : ""}`}
                    // className={`nav-item ${isAuditFormOpen ? "menu-open" : ""}`}
                    onClick={toggleDropdownAuditForm}
                  >
                    <div className={`nav-link  d-flex align-items-center`}>
                      <i className="nav-icon fas fa-edit whitecoloe"></i>
                      <div className="w-100">
                        <p className="d-flex justify-content-between align-items-center whitecoloe">
                          Audit Form
                          {/* <i className="fas fa-angle-right right"></i>        */}
                          <i
                            className={`fas ${
                              isAuditFormOpen
                                ? "fa-angle-down"
                                : "fa-angle-right"
                            }`}
                          ></i>
                        </p>
                      </div>
                    </div>
                    {isAuditFormOpen ? (
                      <ul 
                      // className="nav nav-treeview"
                       className="nav new-data-ui"
                      >
                        <li className="nav-item">
                          <Link
                            to="/audits-questions"
                            className={`nav-link ${
                              (url ===
                                `${process.env.REACT_APP_BASE_NAME}/audits-questions` ||
                                url ===
                                  `${process.env.REACT_APP_BASE_NAME}/create-audit-question` ||
                                url ===
                                  `${process.env.REACT_APP_BASE_NAME}/update-audit-question`) &&
                              "active"
                            }`}
                          >
                            <i class="nav-icon  fas fa-question-circle"></i>
                            <p>Audits Questions</p>
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link
                            to="/audits-images"
                            className={`nav-link ${
                              (url ===
                                `${process.env.REACT_APP_BASE_NAME}/audits-images` ||
                                url ===
                                  `${process.env.REACT_APP_BASE_NAME}/create-audit-images` ||
                                url ===
                                  `${process.env.REACT_APP_BASE_NAME}/update-audit-images`) &&
                              "active"
                            }`}
                          >
                            <i class="nav-icon  fas fa-question-circle"></i>
                            <p>Audits Images</p>
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link
                            to="/audits-extras"
                            className={`nav-link ${
                              (url ===
                                `${process.env.REACT_APP_BASE_NAME}/audits-extras` ||
                                url ===
                                  `${process.env.REACT_APP_BASE_NAME}/create-audit-extras` ||
                                url ===
                                  `${process.env.REACT_APP_BASE_NAME}/update-audit-extras`) &&
                              "active"
                            }`}
                          >
                            <i class="nav-icon  fas fa-question-circle"></i>
                            <p>Audits Extras</p>
                          </Link>
                        </li>
                      </ul>
                    ) : null}
                  </li>
                </>
              )}
              {(decodedToken?.role == 3 || decodedToken?.role == 4 || decodedToken?.role == 1) && (
                <li className="nav-item">
                  <Link
                    to="/admins"
                    className={`nav-link ${
                      (url === `${process.env.REACT_APP_BASE_NAME}/admins` ||
                        url ===
                          `${process.env.REACT_APP_BASE_NAME}/create-admin` ||
                        url ===
                          `${process.env.REACT_APP_BASE_NAME}/update-admin`) &&
                      "active"
                    }`}
                  >
                    <i class="nav-icon fas fa-users-cog"></i>
                    <p>{decodedToken?.role == 1 ? "ECA Admins":"Admins"}</p>
                  </Link>
                </li>
              )}
              {decodedToken?.role == 1 ||
              decodedToken?.role == 4 ||
              decodedToken?.role == 3 ? (
                <li className="nav-item">
                  <Link
                    to="/auditors"
                    className={`nav-link ${
                      (url === `${process.env.REACT_APP_BASE_NAME}/auditors` ||
                        url ===
                          `${process.env.REACT_APP_BASE_NAME}/create-auditor` ||
                        url ===
                          `${process.env.REACT_APP_BASE_NAME}/update-auditor`) &&
                      "active"
                    }`}
                  >
                    <i class="nav-icon fas fa-users"></i>
                    <p>Auditors</p>
                  </Link>
                </li>
              ) : null}
              {decodedToken?.role == 1 ||
              decodedToken?.role == 4 ||
              decodedToken?.role == 5 ||
              decodedToken?.role == 3 ? (
                <li className="nav-item">
                  <Link
                    to="/master-data/centre"
                    className={`nav-link ${
                      (url ===
                        `${process.env.REACT_APP_BASE_NAME}/master-data/centre` ||
                        url ===
                          `${process.env.REACT_APP_BASE_NAME}/master-data/create-centre` ||
                        url ===
                          `${process.env.REACT_APP_BASE_NAME}/master-data/update-centre`) &&
                      "active"
                    }`}
                  >
                    <i class="nav-icon  fas fa-map-marker-alt"></i>
                    <p>Center</p>
                  </Link>
                </li>
              ) : null}
              {/* Master Data Dropdown */}
              {decodedToken?.role == 1 ||
              decodedToken?.role == 4 ||
              decodedToken?.role == 3 ? (
                <li
                  // className={`nav-item ${isMasterDataOpen ? "menu-open" : ""}`}
                  className={`nav-item ${isMasterDataOpen ? "" : ""}`}
                  onClick={toggleDropdown}
                >
                  <div className={`nav-link  d-flex align-items-center `}>
                    <i className="nav-icon fas fa-edit whitecoloe"></i>
                    <div className="w-100">
                      <p className="d-flex justify-content-between align-items-center whitecoloe">
                        Master Data
                        {/* <i className="fas fa-angle-right right"></i>        */}
                        <i
                          className={`fas ${
                            isMasterDataOpen
                              ? "fa-angle-down"
                              : "fa-angle-right"
                          }`}
                        ></i>
                      </p>
                    </div>
                  </div>
                  {isMasterDataOpen ? (
                    <ul 
                    // className="nav nav-treeview"
                     className="nav new-data-ui"
                    >
                      {(decodedToken?.role == 3 || decodedToken?.role == 4) && (
                        <li className="nav-item">
                          <Link
                            to="/master-data/rrb"
                            className={`nav-link ${
                              (url ===
                                `${process.env.REACT_APP_BASE_NAME}/master-data/rrb` ||
                                url ===
                                  `${process.env.REACT_APP_BASE_NAME}/master-data/create-rrb` ||
                                url ===
                                  `${process.env.REACT_APP_BASE_NAME}/master-data/update-rrb`) &&
                              "active"
                            }`}
                          >
                            <i className="far fa-circle nav-icon"></i>
                            <p>RRB</p>
                          </Link>
                        </li>
                      )}
                      <li className="nav-item">
                        <Link
                          to="/master-data/state"
                          className={`nav-link ${
                            (url ===
                              `${process.env.REACT_APP_BASE_NAME}/master-data/state` ||
                              url ===
                                `${process.env.REACT_APP_BASE_NAME}/master-data/create-state` ||
                              url ===
                                `${process.env.REACT_APP_BASE_NAME}/master-data/update-state`) &&
                            "active"
                          }`}
                        >
                          <i className="far fa-circle nav-icon"></i>
                          <p>State</p>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          to="/master-data/city"
                          className={`nav-link ${
                            (url ===
                              `${process.env.REACT_APP_BASE_NAME}/master-data/city` ||
                              url ===
                                `${process.env.REACT_APP_BASE_NAME}/master-data/create-city` ||
                              url ===
                                `${process.env.REACT_APP_BASE_NAME}/master-data/update-city`) &&
                            "active"
                          }`}
                        >
                          <i className="far fa-circle nav-icon"></i>
                          <p>City</p>
                        </Link>
                      </li>
                    </ul>
                  ) : null}
                </li>
              ) : null}
              {decodedToken?.role == 1 ||
              decodedToken?.role == 4 ||
              decodedToken?.role == 3 ? (
                <li className="nav-item">
                  <Link
                    to="/support-ticket"
                    className={`nav-link ${
                      url ===
                        `${process.env.REACT_APP_BASE_NAME}/support-ticket` &&
                      "active"
                    }`}
                  >
                    <i className="nav-icon fas  fa-ticket-alt"></i>
                    <p>Support Ticket</p>
                  </Link>
                </li>
              ) : null}
              {decodedToken?.role == 1 ||
              decodedToken?.role == 4 ||
              decodedToken?.role == 3 ? (
                <li className="nav-item">
                  <Link
                    to="/announcement"
                    className={`nav-link ${
                      url ===
                        `${process.env.REACT_APP_BASE_NAME}/announcement` &&
                      "active"
                    }`}
                  >
                    <i class="nav-icon fas fa-bullhorn"></i>
                    <p>Announcement</p>
                  </Link>
                </li>
              ) : null}
              <li
                className="nav-item"
                data-toggle="modal"
                data-target="#modal-danger-logout"
              >
                <Link className={`nav-link `}>
                  <i class="nav-icon fas fa-sign-out-alt"></i> <p>Log Out</p>
                </Link>
              </li>
            </ul>
          </nav>
          {/* /.sidebar-menu */}
        </div>
        {/* /.sidebar */}
      </aside>
      <Logout logOut={logOut} />
    </div>
  );
}

export default SidebarUi;
